var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("Powered by @Devops Team")])
}
var staticRenderFns = []

export { render, staticRenderFns }